import styled from '@emotion/styled'
import { WppGrid } from '@platform-ui-kit/components-library-react'

export const CatalogueGrid = styled(WppGrid)`
  padding-top: 16px;
  flex: 1;
  margin: 0;
`
